export default __webpack_public_path__ + "static/media/horse.3b1d53bb.jpg";